import { normaliseRoadmap, SCHEMA_VERSION } from './schema';

const COMPRESSED = 'z';
const PLAIN = 'j';

function bytesToBase64Url(bytes) {
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlToBytes(text) {
  const b64 = text.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

async function pipe(bytes, transform) {
  const writer = transform.writable.getWriter();
  writer.write(bytes).catch(() => {});
  writer.close().catch(() => {});
  const reader = transform.readable.getReader();
  const chunks = [];
  let size = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
    size += value.length;
  }
  const out = new Uint8Array(size);
  let offset = 0;
  for (const c of chunks) {
    out.set(c, offset);
    offset += c.length;
  }
  return out;
}

const canCompress = () => typeof CompressionStream === 'function' && typeof DecompressionStream === 'function';

// Baselines and this device's pin/archive flags stay local, which also keeps links short.
export function shareableRoadmap(roadmap) {
  const { baselines, pinned, archived, ...rest } = roadmap;
  return rest;
}

function toSharePayload(roadmap) {
  return { v: SCHEMA_VERSION, sharedAt: new Date().toISOString(), roadmap: shareableRoadmap(roadmap) };
}

export async function encodeRoadmap(roadmap) {
  const json = JSON.stringify(toSharePayload(roadmap));
  const bytes = new TextEncoder().encode(json);
  if (canCompress()) {
    const packed = await pipe(bytes, new CompressionStream('deflate-raw'));
    return COMPRESSED + bytesToBase64Url(packed);
  }
  return PLAIN + bytesToBase64Url(bytes);
}

export async function decodeRoadmap(token) {
  const clean = String(token || '').trim().replace(/^#/, '').replace(/^d=/, '');
  if (clean.length < 2) throw new Error('Empty share link');
  const kind = clean[0];
  let bytes = base64UrlToBytes(clean.slice(1));
  if (kind === COMPRESSED) {
    if (!canCompress()) throw new Error('This browser cannot open compressed links');
    bytes = await pipe(bytes, new DecompressionStream('deflate-raw'));
  } else if (kind !== PLAIN) {
    throw new Error('Unknown share link format');
  }
  const payload = JSON.parse(new TextDecoder().decode(bytes));
  const roadmap = normaliseRoadmap(payload.roadmap || payload);
  return { roadmap, sharedAt: payload.sharedAt || null };
}

export async function buildShareUrl(roadmap, origin = window.location.origin) {
  const token = await encodeRoadmap(roadmap);
  return `${origin}/share#${token}`;
}

export const LONG_LINK_WARNING = 8000;
